<button class="btn btn-flat"
        [matMenuTriggerFor]="menu">dev</button>
<mat-menu #menu="matMenu">
  <button mat-menu-item
          (click)="onTriggerPushArrived()">trigger push-arrived</button>
  <button mat-menu-item
          (click)="onTriggerAppResumed()">trigger app-resumed</button>
</mat-menu>
